
import { z } from "zod";

export const sistemaBaseSchema = z.object({
  nome: z.string().min(3, { message: "Nome deve ter pelo menos 3 caracteres" }),
  descricao: z.string().optional(),
  valorPorKwp: z.coerce.number().positive({ message: "Valor por kWp deve ser positivo" }),
  eficiencia: z.coerce.number().min(0.7).max(1, { message: "Eficiência deve estar entre 0.7 e 1" }),
  perdas: z.coerce.number().min(0).max(0.3, { message: "Perdas devem estar entre 0 e 0.3" }),
  fatorSimultaneidade: z.coerce.number().min(0.8).max(1, { message: "Fator de simultaneidade deve estar entre 0.8 e 1" }),
  fatorCapacidade: z.coerce.number().min(0.15).max(0.25, { message: "Fator de capacidade deve estar entre 0.15 e 0.25" }),
  estruturas: z.array(z.object({
    tipo: z.string(),
    valorPorKwp: z.coerce.number().positive({ message: "Valor por kWp deve ser positivo" }),
    descricao: z.string().optional(),
  })),
  marcaPadraoPainel: z.string().optional(),
  modeloPadraoPainel: z.string().optional(),
  fotoPadraoPainel: z.string().optional(),
  marcaPadraoInversor: z.string().optional(),
  modeloPadraoInversor: z.string().optional(),
  fotoPadraoInversor: z.string().optional(),
});

export type SistemaFormValues = z.infer<typeof sistemaBaseSchema>;
